import { SHELF_CARD_COVERS } from "./shelfArticles";

export const CURATED_SHELVES = [
  {
    slug: "the-quiet-shelf",
    tag: "Staff Pick",
    title: "The Quiet Shelf",
    author: "Mira Holloway",
    img: SHELF_CARD_COVERS["the-quiet-shelf"],
    desc: "Slow novels for slower Sundays.",
    longDesc:
      "A sanctuary for unhurried reading — soft epistolary fiction, garden-paced novels, and essays that leave room for your own thoughts between the lines.",
    moods: ["Slow living", "Sundays", "Reflective"],
    bookCount: "24 titles",
  },
  {
    slug: "reader-circles",
    tag: "Trending",
    title: "Reader Circles",
    author: "PagePeers Editors",
    img: SHELF_CARD_COVERS["reader-circles"],
    desc: "What our community is reading this week.",
    longDesc:
      "Live picks from active reader circles — the books generating the warmest threads, highest saves, and most generous spoiler-safe discussions this week.",
    moods: ["Community", "Trending", "Discussion"],
    bookCount: "12 titles",
  },
  {
    slug: "weekend-escape",
    tag: "New",
    title: "Weekend Escape",
    author: "Arjun Mehra",
    img: SHELF_CARD_COVERS["weekend-escape"],
    desc: "Page-turners for lazy afternoons.",
    longDesc:
      "Propulsive fiction for two-sitting weekends — coastal noir, bookshop romances, and heist stories with heart that respect your need to nap between chapters.",
    moods: ["Page-turners", "Weekend", "Fun"],
    bookCount: "18 titles",
  },
  {
    slug: "timeless-voices",
    tag: "Classic",
    title: "Timeless Voices",
    author: "Neha Saxena",
    img: SHELF_CARD_COVERS["timeless-voices"],
    desc: "Books that have outlasted the noise.",
    longDesc:
      "Enduring novels and essays that still feel immediate — curated for readers who want substance without pretension, and stories that reward a second visit.",
    moods: ["Classics", "Literary", "Enduring"],
    bookCount: "30 titles",
  },
  {
    slug: "letters-and-tea",
    tag: "Loved",
    title: "Letters & Tea",
    author: "Priya Rao",
    img: SHELF_CARD_COVERS["letters-and-tea"],
    desc: "Quiet essays, memoirs, and warm prose.",
    longDesc:
      "Intimate voices in epistolary essays, fragmented memoir, and observational prose — the shelf you open when you want to feel understood, not instructed.",
    moods: ["Memoir", "Essays", "Warm"],
    bookCount: "16 titles",
  },
  {
    slug: "rainy-day-reads",
    tag: "Cozy",
    title: "Rainy Day Reads",
    author: "PagePeers Club",
    img: SHELF_CARD_COVERS["rainy-day-reads"],
    desc: "Curled-up-under-a-blanket stories.",
    longDesc:
      "Atmospheric fiction and memoir for grey skies — small towns, found families, and gentle mysteries you can read under fleece without adrenaline overload.",
    moods: ["Cozy", "Rainy day", "Comfort"],
    bookCount: "20 titles",
  },
];

export const SHELVES_PILLARS = [
  {
    title: "Editorial shelves",
    desc: "Staff picks and themed collections built by PagePeers editors — slow Sundays, debut voices, rainy afternoons, and more.",
  },
  {
    title: "Community shelves",
    desc: "Public lists from readers like you, ranked by saves and circle activity. Discovery that feels like a friend’s recommendation.",
  },
  {
    title: "Living collections",
    desc: "Shelves update as members add titles, vote, and discuss. Follow any shelf and get a gentle nudge when something new appears.",
  },
];

export const SHELF_MOODS = [
  "All moods",
  "Slow living",
  "Cozy",
  "Page-turners",
  "Classics",
  "Community",
  "Reflective",
  "Weekend",
];

export const SHELVES_HOW_IT_WORKS = [
  {
    step: "01",
    title: "Browse curated shelves",
    body: "Explore editorial collections and community lists organized by mood, genre, and reading occasion — not by algorithmic guesswork.",
  },
  {
    step: "02",
    title: "Open a shelf story",
    body: "Each shelf includes a curator’s essay, reading tips, and context for why these books belong together. Tap Open shelf to read the full guide.",
  },
  {
    step: "03",
    title: "Save to your library",
    body: "Add individual titles or the entire shelf to your PagePeers wishlist. Follow the shelf to hear when new books are added.",
  },
];

export const SHELVES_FAQ = [
  {
    q: "What is a shelf on PagePeers?",
    a: "A shelf is a curated collection of books with a theme, a curator’s voice, and optional discussion in reader circles. Think playlist, but for reading.",
  },
  {
    q: "Can I create my own shelf?",
    a: "Yes. Build a public or private shelf, organize it your way, and share the link with friends or your circle.",
  },
  {
    q: "How often do shelves update?",
    a: "Editorial shelves refresh monthly. Community and circle-driven shelves can update weekly as members vote and add titles.",
  },
  {
    q: "Are shelf essays free to read?",
    a: "All curated shelf guides on PagePeers are free to read. Saving books and joining circles may require a free account.",
  },
];

export const SHELVES_STATS = [
  { value: "850+", label: "Public shelves" },
  { value: "6", label: "Featured collections" },
  { value: "120", label: "Active circles" },
  { value: "4.8", label: "Avg reader rating" },
];
